import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@hooks/auth/auth-config';
import { TrocarTokenPorJwt, GetUsuarioSessao } from '@services/Auth/Index';
import { localSignOut } from '@utils/auth/localSignOut';

export default function AuthCallback() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const handleAuth = async () => {
      try {
        const accounts = instance.getAllAccounts();
        if (!accounts.length) {
          if (!cancelled)
            navigate('/Login', { replace: true, state: { showWelcome: true } });
          return;
        }

        // 'manual' quando a tela de login setou esse flag; padrão: 'sso'
        const storedMode = sessionStorage.getItem('authMode');
        const authMode = storedMode === 'manual' ? 'manual' : 'sso';

        const { accessToken } = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        await TrocarTokenPorJwt(accessToken, authMode);
        sessionStorage.removeItem('authMode');

        const usuario = await GetUsuarioSessao();
        if (!usuario?.email) {
          const err = new Error('Forbidden');
          err.status = 403;
          throw err;
        }

        if (!cancelled)
          navigate('/', { replace: true, state: { showWelcome: true } });
      } catch (err) {
        const status = err?.status || err?.response?.status;

        if (status === 401) {
          localSignOut(instance);
          if (!cancelled) navigate('/Login', { replace: true });
          return;
        }

        if (status === 403) {
          localSignOut(instance);
          if (!cancelled) navigate('/erro403', { replace: true });
          return;
        }

        if (status >= 500 && status < 600) {
          console.error('[AuthCallback] Erro servidor (5xx):', err);
          if (!cancelled) navigate('/Login', { replace: true });
          return;
        }

        console.error('[AuthCallback] Erro inesperado:', err);
        if (!cancelled) navigate('/Login', { replace: true });
      }
    };

    handleAuth();
    return () => {
      cancelled = true;
    };
  }, [instance, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      Validando login…
    </div>
  );
}
